<template>
	<!-- Sign In Form -->
	<div>
		<img
			src="https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/2b789c4f_1734502479449_sc.png"
			alt="Logo"
			class="full-width px-4 pr-5 pb-4"
		/>
		<v-form
			ref="sign-in-form"
			class="full-width px-4"
			v-model="signInForm"
			@submit.prevent
		>
			<div class="pl-2">
				{{
					showSignInForm
						? "Sign in to continue"
						: "Reset your password"
				}}
			</div>
			<div v-if="showSignInForm">
				<v-layout wrap>
					<div class="full-width">
						<v-text-field
							v-model="username"
							label="Username/Phone No"
							placeholder="Enter Username/Phone No"
							class="body-1 text-field-wrapper pt-4"
						></v-text-field>
					</div>
					<div class="pt-2 full-width">
						<v-text-field
							v-model="password"
							type="password"
							label="Password"
							placeholder="Enter Password"
							class="body-1 text-field-wrapper pt-4"
							@keyup.enter="tryLogIn"
						/>
					</div>
				</v-layout>
			</div>
			<v-layout v-else>
				<v-flex class="allCenteredChild">
					<v-text-field
						v-model="phone"
						@keyup.enter="sendOtp"
						label="Phone Number"
						placeholder="Enter Phone No"
						class="body-1 text-field-wrapper pt-4"
						:rules="[validPhoneNoRule]"
					></v-text-field>
					<v-btn
						:disabled="disableSendOtpButton"
						small
						flat
						:loading="tryingSendOtp"
						:color="themeInputColor"
						@click="sendOtp"
					>
						{{ otpSent ? "Resend" : "Send" }}
						OTP
					</v-btn>
				</v-flex>
			</v-layout>

			<template v-if="otpSent && !showSignInForm">
				<v-layout>
					<v-flex class="pt-4">
						<v-text-field
							v-model="otp"
							label="OTP"
							placeholder="Enter OTP"
							class="body-1 text-field-wrapper pt-4"
							:rules="[requiredRule, onlyDigitRule]"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<div class="d-flex no-flex-grow">
						<v-text-field
							v-model="newPassword"
							type="password"
							label="Password"
							placeholder="New Password"
							class="body-1 text-field-wrapper pt-4"
							:rules="[requiredRule, validPasswordRule]"
						/>
						<v-text-field
							v-model="confirmPassword"
							type="password"
							label="Confirm Password"
							placeholder="Confirm Password"
							class="body-1 text-field-wrapper pt-4"
							:rules="[requiredRule, checkPasswordMatching]"
						/>
					</div>
				</v-layout>
			</template>

			<v-layout>
				<v-flex class="d-flex pt-3">
					<v-btn
						@click="takeAction"
						large
						class="btn white--text mx-0"
						:disabled="actionButtonDisabled"
						:loading="takeActionLoading"
						:color="themeInputColor"
						>{{
							showSignInForm ? "Log In" : "Change Password"
						}}</v-btn
					>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="allCenteredChild">
					<v-btn
						small
						flat
						@click="showSignInForm = !showSignInForm"
						:color="themeInputColor"
						>{{
							showSignInForm ? "forgot password" : "Try LogIn"
						}}</v-btn
					>
					<v-btn
						@click="signUpClick"
						small
						flat
						:color="themeInputColor"
						>New User? Sign Up</v-btn
					>
				</v-flex>
			</v-layout>
		</v-form>
	</div>
</template>

<script>
import {
	USER_SIGN_IN,
	USER_FORGOT_PASSWORD_SEND_OTP,
	USER_RESET_PASSWORD
} from "@/store/action-types";
import * as utils from "@/utils";

export default {
	name: "SignInForm",
	props: ["themeInputColor"],
	data() {
		return Object.assign(
			{
				signInForm: false,
				username: null,
				password: null,
				onlyDigitRule: v => utils._onlyDigitsRule(v),
				requiredRule: v => utils._requiredRule(v),
				validPhoneNoRule: v => utils._validPhoneNoRule(v)
			},
			initialState
		);
	},
	methods: {
		signUpClick() {
			this.$emit("showSignUp");
		},

		takeAction() {
			if (this.showSignInForm) {
				return this.tryLogIn();
			}
			return this.resetPassword();
		},

		tryLogIn() {
			if (!this.takeActionLoading) {
				this.takeActionLoading = true;
				this.$store
					.dispatch(USER_SIGN_IN.dispatch, {
						username: this.username,
						password: this.password,
						toolName: "retail"
					})
					.finally(() => {
						this.takeActionLoading = false;
					});
			}
		},

		sendOtp() {
			if (!this.tryingSendOtp) {
				this.tryingSendOtp = true;
				this.$store
					.dispatch(USER_FORGOT_PASSWORD_SEND_OTP.dispatch, {
						phone: parseInt(this.phone, 10),
						countryAreaCode: 91
					})
					.then(id => {
						this.otpSent = true;
						this.id = id;
					})
					.catch(() => {})
					.then(() => {
						this.tryingSendOtp = false;
					});
			}
		},

		resetPassword() {
			if (!this.takeActionLoading) {
				this.takeActionLoading = true;
				this.$store
					.dispatch(USER_RESET_PASSWORD.dispatch, {
						id: this.id,
						otp: this.otp,
						newPassword: this.newPassword
					})
					.then(() => {
						Object.keys(initialState).map(key => {
							this.$set(this, key, initialState[key]);
						});
					})
					.catch(() => {})
					.finally(() => {
						this.takeActionLoading = false;
					});
			}
		}
	},

	computed: {
		checkPasswordMatching() {
			if (this.newPassword && this.newPassword === this.confirmPassword) {
				return true;
			}
			return "Passwards do not match.";
		},
		actionButtonDisabled() {
			if (this.showSignInForm) {
				return false;
			}
			return (
				!Number(this.otp) ||
				!this.newPassword ||
				!this.confirmPassword ||
				this.checkPasswordMatching !== true ||
				this.validPasswordRule !== true
			);
		},
		validPasswordRule() {
			return (
				(typeof this.newPassword === "string" &&
					this.newPassword.length >= 8) ||
				"Min. 8 characters are required"
			);
		},
		disableSendOtpButton() {
			return this.validPhoneNoRule(this.phone) !== true;
		}
	}
};
const initialState = {
	takeActionLoading: false,
	phone: null,
	otp: null,
	newPassword: null,
	confirmPassword: null,
	showSignInForm: true,
	id: null,
	otpSent: false,
	tryingSendOtp: false
};
</script>
